import {Usuario} from '../../../usuario/recursos/modelo/usuario';
import {Certificado} from './certificado';
import {ParserType} from './ParserType';
import {Aplicaciones} from './Aplicaciones';
import {IntegrationType} from './IntegrationType';
import {PdfDocumentTemplate} from './PdfDocumentTemplate';
import {MenuBackColor} from './MenuBackColor';
import {MenuSelectorColor} from './MenuSelectorColor';
import {BillingConfiguration} from './emisor-configuration';
import {StockProducts} from './stockProducts';
import {Receiver} from './Receiver';
import {GrePoint} from "./gre-point";
import {GreCarrier} from "./gre-carrier";

export class Emisor {
    public id: number;
    public ruc: string;
    public nombre: string;
    public lastRequestDate: string;
    public goodReqCounter: number;
    public failReqCounter: number;
    public logo: string;
    public estado: string;
    public condicionDomicilio: string;
    public ubigeo: string;
    public tipoVia: string;
    public nombreVia: string;
    public codigoZona: string;
    public tipoZona: string;
    public numero: string;
    public interior: string;
    public lote: string;
    public departamento: string;
    public manzana: string;
    public kilometro: string;
    public distrito: string;
    public provincia: string;
    public usuarios: Usuario[];
    public customerRequests: any;
    public nombreFoto: string;
    public clientPortalToken: string;
    public correo: string;
    // PSE
    public posee_PSE: boolean;
    public posee_VALIDADOR: boolean;
    public posee_ADMIN: boolean;
    public posee_EMISOR: boolean;

    public rutaCertificado: string;
    public certificate: string;
    public certificateTO: Certificado;
    public certificatePassword: string;
    public integrationType: string;
    public ownCertificate: boolean;
    public parserType: ParserType;
    public parserTypeId: number;
    public applications: Aplicaciones[];

    public responseType: string;
    public banner: string;
    public pdfDocumentTemplate: PdfDocumentTemplate;
    public pdfCustomFooter: string;
    public emailSubject: String;


    public email_hi_color: string;
    public email_start_message: string;
    public email_start_message_color: string;
    public information_additional: string;
    public emailFooter: string;
    public email_template_id: number;

    public menuBackColor: MenuBackColor;
    public menuSelectorColor: MenuSelectorColor;
    public menuBackgroundType: string;
    public menuBackgroundImage: number;
    public docker: any;

    // ENMASCARAMIENTO DE CORREO
    public emailMasked: boolean;

    public emailAttachments: boolean;
    public emailLogo: string;

    public emailFrom: string;
    public igv: number;

    // AUDITORIA INTERNA
    public logEstatusRegistro: string;
    public logUsernameRegistro: string;
    public logFechaRegistro: string;
    public logUsernameModificacion: string;
    public logFechaModificacion: string;
    // CONFIGURATION
    public billingList: BillingConfiguration[];
    public productsStockList: StockProducts[];
    public receiverList: Receiver[];
    public grePointList: GrePoint[];
    public greCarrierList: GreCarrier[];
    public type: String;
    public affiliates: Emisor[];
    public salesRecord: boolean;
    public dailySummary: boolean;
    public dailySummaryRows: number;

    public bcpAdditionalFilters: boolean;

    // MailJet section
    public enabledMailjet: boolean;
    public mailjetApikey: string;
    public mailjetApiSecret: string;
    public mailjetLogDebug: number;

    // GetStatusCDR section
    public enableGetStatusCDR: boolean;
    public enableSendMailCDR: boolean;

    // COS section
    public enabledCOS: boolean;
    public cloudServiceID: string;
    public cloudServiceDate: string;
    public amountWithIGV: boolean;
    public enabledHistory: boolean;
    constructor(id: number = null,
                ruc: string = '',
                nombre: string = '',
                lastRequestDate: string = null,
                goodReqCounter: number = null,
                failReqCounter: number = null,
                logo: string = null,
                estado: string = '',
                condicionDomicilio: string = '',
                ubigeo: string = '',
                tipoVia: string = '',
                nombreVia: string = '',
                codigoZona: string = '',
                tipoZona: string = '',
                numero: string = '',
                interior: string = '',
                lote: string = '',
                departamento: string = '',
                manzana: string = '',
                kilometro: string = '',
                distrito: string = '',
                provincia: string = '',
                usuarios: Usuario[] = [],
                customerRequests: any = '',
                nombreFoto: string = '',
                logEstatusRegistro: string = 'ACTIVO',
                logUsernameRegistro: string = '',
                logFechaRegistro: string = null,
                logUsernameModificacion: string = null,
                logFechaModificacion: string = null,
                certificadoTo: Certificado = new Certificado(),
                certificado: string = '',
                responseType: string = 'SOAPFAULT',
                certificadoPropio: boolean = false,
                rutaCertificado: string = null,
                parserType: ParserType = new ParserType(),
                parserTypeId: number = null,
                pdfDocumentTemplate = new PdfDocumentTemplate(),
                integrationType: IntegrationType = IntegrationType.REST,
                billingList?: BillingConfiguration[],
                productsStockList?: StockProducts[],
                receiverList?: Receiver[],
                grePointList?: GrePoint[],
                greCarrierList?: GreCarrier[],
                aplicaciones?: any,
                banner: string = null,
                email_template_id: number = 0,
                igv: number = 18.0,
                email_start_message: string = '',
                email_start_message_color: string = '#000000',
                emailFooter: string = '',
                email_hi_color: string = '#000000',
                information_additional: string = '',
                menuBackColor: MenuBackColor = MenuBackColor.OSCURO,
                menuSelectorColor: MenuSelectorColor = MenuSelectorColor.BLANCO,
                menuBackgroundImage: number = 0,
                docker?: any,
                clientPortalToken: string = '',
                posee_pse: boolean = true,
                correo: string = '',
                pdfCustomFooter: string = '',
                type: string = 'GENERAL',
                affiliates: Emisor[] = [],
                emailMasked: boolean = false,
                emailAttachments: boolean = true,
                emailFrom: string = '',
                emailSubject: string = '',
                emailLogo: string = null,
                salesRecord: boolean = false,
                dailySummary: boolean = false,
                bcpAdditionalFilters: boolean = false,
                dailySummaryRows: number = 0,
                enabledMailjet: boolean = false,
                mailjetApikey: string = '',
                mailjetApiSecret: string = '',
                mailjetLogDebug: number = 0,
                enableGetStatusCDR: boolean = true,
                enableSendMailCDR: boolean = false,
                enabledCOS: boolean = false,
                amountWithIGV: boolean = false,
                enabledHistory: boolean = false,
                cloudServiceID: string = 'LOCAL',
                cloudServiceDate: string = null,
    ) {

        this.id = id;
        this.ruc = ruc;
        this.nombre = nombre;
        this.lastRequestDate = lastRequestDate;
        this.goodReqCounter = goodReqCounter;
        this.failReqCounter = failReqCounter;
        this.logo = logo;
        this.estado = estado;
        this.condicionDomicilio = condicionDomicilio;
        this.ubigeo = ubigeo;
        this.tipoVia = tipoVia;
        this.nombreVia = nombreVia;
        this.codigoZona = codigoZona;
        this.tipoZona = tipoZona;
        this.numero = numero;
        this.interior = interior;
        this.lote = lote;
        this.igv = igv;
        this.departamento = departamento;
        this.manzana = manzana;
        this.kilometro = kilometro;
        this.provincia = provincia;
        this.distrito = distrito;
        this.usuarios = usuarios;
        this.customerRequests = customerRequests;
        this.nombreFoto = nombreFoto;
        this.rutaCertificado = rutaCertificado;
        this.certificateTO = certificadoTo;
        this.ownCertificate = certificadoPropio;
        this.correo = correo;

        this.responseType = this.responseType;

        this.grePointList = grePointList;
        this.greCarrierList = greCarrierList;
        this.banner = banner;
        this.email_start_message = email_start_message;
        this.email_hi_color = email_hi_color;
        this.email_start_message_color = email_start_message_color;
        this.information_additional = information_additional;
        this.emailFooter = emailFooter;
        this.email_template_id = email_template_id;
        this.enabledHistory = enabledHistory;

        this.bcpAdditionalFilters = bcpAdditionalFilters;

        this.parserType = parserType;
        this.parserTypeId = parserTypeId;
        if (aplicaciones) {
            this.applications = aplicaciones;
        } else {
            this.applications = [];
            this.applications.push(Aplicaciones.VALIDADOR);
            this.applications.push(Aplicaciones.ADMINISTRADOR);
            this.applications.push(Aplicaciones.TRANSFORMADOR);
            this.posee_PSE = true;
            this.posee_VALIDADOR = true;
            this.posee_ADMIN = true;
            this.posee_EMISOR = false;
        }
        this.parserType = parserType;
        this.integrationType = integrationType;
        this.pdfDocumentTemplate = pdfDocumentTemplate;

        this.menuBackgroundType = 'IMAGE';
        this.menuBackColor = menuBackColor;
        this.menuSelectorColor = menuSelectorColor;
        this.menuBackgroundImage = menuBackgroundImage;
        this.docker = docker;

        this.clientPortalToken = clientPortalToken;

        if (billingList) {
            this.billingList = billingList;
        } else {
            this.billingList = [];
        }
        if (productsStockList) {
            this.productsStockList = productsStockList;
        } else {
            this.productsStockList = [];
        }
        if (receiverList) {
            this.receiverList = receiverList;
        } else {
            this.receiverList = [];
        }
        this.pdfCustomFooter = pdfCustomFooter;
        this.type = type;
        this.affiliates = affiliates;

        this.emailMasked = emailMasked;
        this.emailAttachments = emailAttachments;
        this.emailFrom = emailFrom;
        this.emailSubject = emailSubject;
        this.emailLogo = emailLogo;


        // CAMPOS DE AUDITORIA
        this.logEstatusRegistro = logEstatusRegistro;
        this.logUsernameRegistro = logUsernameRegistro;
        this.logFechaRegistro = logFechaRegistro;
        this.logUsernameModificacion = logUsernameModificacion;
        this.logFechaModificacion = logFechaModificacion;

        this.salesRecord = salesRecord;
        this.dailySummary = dailySummary;
        this.dailySummaryRows = dailySummaryRows;

        // MailJet section
        this.enabledMailjet = enabledMailjet;
        this.mailjetApikey = mailjetApikey;
        this.mailjetApiSecret = mailjetApiSecret;
        this.mailjetLogDebug = mailjetLogDebug;

        // GetStatusCDR section
        this.enableGetStatusCDR = enableGetStatusCDR;
        this.enableSendMailCDR = enableSendMailCDR;

        this.amountWithIGV = amountWithIGV;
        // COS section
        this.enabledCOS = enabledCOS;
        this.cloudServiceID = cloudServiceID;
        this.cloudServiceDate = cloudServiceDate;

    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/recursos/modelo/emisor.ts